import { r as registerInstance, h, H as Host, g as getElement } from './index-8f7fb048.js';
import { s as submitFormImplicitly } from './forms-eb6a5fcc.js';
import { g as getNamespacedTagFor } from './index-739b155e.js';

const marketInputPasswordCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{display:block}.toggle{cursor:pointer}";

const MarketInputPassword = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.inputId = undefined;
    this.name = undefined;
    this.value = undefined;
    this.placeholder = undefined;
    this.maxlength = undefined;
    this.minlength = undefined;
    this.size = 'large';
    this.readonly = undefined;
    this.disabled = undefined;
    this.focused = undefined;
    this.invalid = undefined;
    this.autocomplete = undefined;
    this.inputmode = undefined;
    this.type = 'password';
  }
  /**
   * Sets focus styling on `<market-input-password>`. Toggles focus on the inner `<input>` if true, and blurs focus if false.
   */
  async setFocus(value = true) {
    if (this.disabled || this.readonly) {
      return;
    }
    this.focused = value;
    await this.marketInputText.setFocus(value);
  }
  registerSlottedInput() {
    // We need to pass in the slotted input here since it's inside market-input-password's
    // light DOM, and market-input-text is unable to find it.
    this.slottedInput = this.el.querySelector('input[slot=input]');
    if (this.slottedInput) {
      this.marketInputText.registerSlottedInput(this.slottedInput);
    }
  }
  togglePasswordVisibility(e) {
    this.type = this.type === 'password' ? 'text' : 'password';
    e.stopPropagation();
  }
  handleKeyDown(e) {
    if (e.key === 'Enter') {
      submitFormImplicitly(this.el);
    }
  }
  render() {
    const MarketInputTextTagName = getNamespacedTagFor('market-input-text');
    return (h(Host, { class: "market-input-password", onBlur: () => {
        this.marketInputText.focused = false;
      }, onClick: () => {
        this.marketInputText.setFocus();
      }, onFocus: () => {
        this.marketInputText.setFocus();
      }, onKeyDown: (e) => {
        this.handleKeyDown(e);
      } }, h(MarketInputTextTagName, { type: this.type, ref: (el) => (this.marketInputText = el), onBlur: () => { }, onClick: () => { }, onFocus: () => { }, inputId: this.inputId, name: this.name, placeholder: this.placeholder, maxlength: this.maxlength, minlength: this.minlength, size: this.size, value: this.value, readonly: this.readonly, disabled: this.disabled, invalid: this.invalid, autocomplete: this.autocomplete, inputmode: this.inputmode }, h("slot", null), h("slot", { name: "input", onSlotchange: () => this.registerSlottedInput(),
      // if there is a slotted input, assign it to market-input-text's "input" slot
      slot: this.slottedInput ? 'input' : '' }), h("svg", { class: "toggle", slot: "trailing-accessory", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", onClick: (e) => {
        this.togglePasswordVisibility(e);
      } }, this.type === 'password' && (h("g", { "clip-path": "url(#clip0)" }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M1.70711 0.292878C1.31658 -0.0976463 0.683418 -0.0976463 0.292893 0.292878C-0.0976311 0.683402 -0.0976311 1.31657 0.292893 1.70709L2.55013 3.96433C1.38429 4.94208 0.502299 6.23046 0.0449702 7.70347C-0.0149901 7.8966 -0.0149901 8.10337 0.0449702 8.29649C1.07604 11.6175 4.26567 14 8 14C9.33924 14 10.6084 13.6936 11.7331 13.1473L14.2929 15.7071C14.6834 16.0976 15.3166 16.0976 15.7071 15.7071C16.0976 15.3166 16.0976 14.6834 15.7071 14.2929L13.4499 12.0356C14.6157 11.0579 15.4977 9.76951 15.955 8.29649C16.015 8.10337 16.015 7.8966 15.955 7.70347C14.924 4.38251 11.7343 1.99998 8 1.99998C6.66076 1.99998 5.39158 2.30641 4.26689 2.85266L1.70711 0.292878ZM2.05607 7.99998C2.43683 6.97522 3.10489 6.07286 3.9716 5.3858L6.0677 7.4819C6.0235 7.64714 5.99994 7.82082 5.99994 8C5.99994 9.10457 6.89537 10 7.99994 10C8.17912 10 8.3528 9.97644 8.51804 9.93224L10.2077 11.6219C9.52221 11.866 8.77873 12 8 12C5.23524 12 2.91488 10.3113 2.05607 7.99998ZM9.93221 8.51798L12.0284 10.6142C12.8951 9.92711 13.5632 9.02475 13.9439 7.99998C13.0851 5.68863 10.7648 3.99998 8 3.99998C7.22127 3.99998 6.47779 4.13395 5.7923 4.37807L7.48196 6.06773C7.64716 6.02355 7.8208 6 7.99994 6C9.10451 6 9.99994 6.89543 9.99994 8C9.99994 8.17914 9.97639 8.35277 9.93221 8.51798Z", fill: "black", "fill-opacity": "0.3" }))), this.type === 'text' && (h("g", { "clip-path": "url(#clip0)" }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8.00006 12C5.2353 12 2.91494 10.3114 2.05613 8C2.91494 5.68865 5.2353 4 8.00006 4C10.7648 4 13.0852 5.68865 13.944 8C13.0852 10.3114 10.7648 12 8.00006 12ZM8.00006 2C4.26573 2 1.0761 4.38252 0.0450312 7.70349C-0.014929 7.89662 -0.014929 8.10338 0.0450312 8.29651C1.0761 11.6175 4.26573 14 8.00006 14C11.7344 14 14.924 11.6175 15.9551 8.29651C16.0151 8.10338 16.0151 7.89662 15.9551 7.70349C14.924 4.38252 11.7344 2 8.00006 2ZM8.00006 10C9.10463 10 10.0001 9.10457 10.0001 8C10.0001 6.89543 9.10463 6 8.00006 6C6.89549 6 6.00006 6.89543 6.00006 8C6.00006 9.10457 6.89549 10 8.00006 10Z", fill: "black", "fill-opacity": "0.3" }))), h("defs", null, h("clipPath", { id: "clip0" }, h("rect", { width: "16", height: "16", fill: "white" })))))));
  }
  get el() { return getElement(this); }
};
MarketInputPassword.style = marketInputPasswordCss;

export { MarketInputPassword as market_input_password };
